module.exports = __webpack_public_path__ + "img/daftar-client.c5fe397e.svg";